/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import { BasicSeparator, DangerButtonSecondary, PageTitle } from 'design-system';
import * as React from 'react';
import { translate } from '../../../helpers/l10n';

interface Props {
  displayReset: boolean;
  onReset: () => void;
}

export function FiltersHeader({ displayReset, onReset }: Props) {
  return (
    <div className="sw-mb-5">
      <div className="sw-flex sw-h-9 sw-items-center sw-justify-between">
        <PageTitle className="sw-body-md-highlight" as="h2" text={translate('filters')} />

        {displayReset && (
          <DangerButtonSecondary onClick={onReset}>
            {translate('clear_all_filters')}
          </DangerButtonSecondary>
        )}
      </div>

      <BasicSeparator className="sw-mt-4" />
    </div>
  );
}
